import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        occurrence: '=',
        occurrenceTrainings: '=',
        trainers: '=',
        trainingCompanies: '=',
        rooms: '=',
        participants: '=',
        trainingTimesWithParticipants: '=',
        courseVersion: '='
    },
    template: `
        <h3>{{ 'occurrence.Schedule' | translate }}</h3>
        <div class="form">
            <div class="row">
                <span class="label">{{ 'occurrence.Associated employees' | translate }}</span>
                <div class="items">
                    <span class="text">{{ vm.occurrence.courseOccurrenceParticipants.length }}</span>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ 'occurrence.Order of trainings' | translate }}</span>
                <div class="items">
                    <span class="text" ng-if="vm.isTrainingOrderSequence">{{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.LABELS.SEQUENCE }}</span>
                    <span class="text" ng-if="!vm.isTrainingOrderSequence">{{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.LABELS.ANY }}</span>
                </div>
            </div>
            <div class="row">
                <span class="label">{{ 'occurrence.Planning recommendation' | translate }}</span>
                <div class="items">
                    <span class="text">{{ vm.course.activeI18n.planningRecommendation }}</span>
                </div>
            </div>
            <div class="row" ng-if="vm.hasClassRoomTrainings || vm.hasWebinarTrainings">
                <span class="label">{{ 'occurrence.Employees are not allowed to register to trainings themselves' | translate }}</span>
                <div class="items">
                    <ul class="checkboxes">
                        <li><input type="checkbox" ng-model="vm.occurrence.isSelfRegistrationDisabled"></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="alert alert-danger ng-binding ng-scope" ng-if="vm.errors">{{ 'general.There were errors processing the form' | translate }}</div>
        <div class="alert alert-warn ng-binding ng-scope" ng-if="vm.classroomIsTooSmall"
        >{{ 'general.Selected classroom is too small' | translate }}</div>
        <div class="alert alert-success ng-binding ng-scope" ng-if="vm.dataSaved">{{ 'general.Changes saved' | translate }}</div>
        <div class="form">
            <form-row error="vm.occurrence.errors.status">
                <p ng-if="vm.occurrence.errors.status" class="desc error" ng-bind-html="vm.occurrence.errors.status"></p>
            </form-row>
            <form-row error="vm.occurrence.errors.feedbackDeadline">
                <form-row-error></form-row-error>
            </form-row>
            <div ng-if="vm.isTrainersUpdated" ng-repeat="(index, training) in vm.trainings track by training.id">
                <hr>
                <div class="heading01 type01">
                    <h3>
                        {{ training.name }}
                        <span ng-if="training.needsAssessment" class="tag color01">{{ 'forms.Needs assessment' | translate }}</span>
                    </h3>
                    <a ng-if="(training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM || training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR) && vm.canManageOccurrences"
                    class="btn add" ng-click="vm.manageTrainingTime(training)">{{ 'occurrence.Add training time' | translate }}</a>
                    <a ng-if="training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST && vm.canManageOccurrences && !vm.isThereOnlyOneTestTimeWithoutRoomRequired(training)"
                    class="btn add" ng-click="vm.manageTrainingTime(training)">{{ 'occurrence.Add test time' | translate }}</a>
                </div>
                <div ng-if="vm.isThereOnlyOneTestTimeWithoutRoomRequired(training)">
                    <a class="btn bordered02" ng-click="vm.viewResults(training)">{{ 'occurrence.Display results' | translate }}</a>
                </div>
                <div class="alert alert-danger ng-binding ng-scope" ng-if="training.errors && training.errors.trainingQuestion">{{ training.errors.trainingQuestion }}</div>
                <div class="form" ng-if="training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE">
                    <form-row error="training.errors.deadline">
                        <label class="label">{{ 'occurrence.Deadline' | translate }}</label>
                        <div class="items">
                            <datetimepicker
                                ng-model="training.deadline"
                                default-time="'23:59'"
                                ng-disabled="!vm.canManageOccurrences">
                            </datetimepicker>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="training.errors.trainerIds">
                        <label class="label">{{ 'occurrence.Trainer' | translate }}</label>
                        <div class="items">
                            <tags-input
                                key-property="id"
                                ng-disabled="!vm.canManageOccurrences"
                                ng-model="training.trainers"
                                add-from-autocomplete-only="true"
                                display-property="displayName"
                                replace-spaces-with-dashes="false"
                                on-tag-removed="vm.$scope.$emit('trainer:remove', $tag.id)"
                                placeholder="{{ 'occurrence.Find a trainer' | translate }}">
                                <auto-complete min-length="1" load-on-empty="false" source="vm.filterTrainers($query)"></auto-complete>
                            </tags-input>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="training.errors.suggestedStartTime" ng-if="vm.onlineExtraOptions[index]==true">
                        <label class="label">{{ 'occurrence.Suggested start time' | translate }}</label>
                        <div class="items">
                            <datetimepicker
                                ng-model="training.suggestedStartTime"
                                ng-disabled="!vm.canManageOccurrences">
                            </datetimepicker>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="training.errors.includeCalendarInvite" ng-if="vm.onlineExtraOptions[index]==true">
                        <span class="label">{{ 'occurrence.Include calendar invite' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox" ng-model="training.includeCalendarInvite">
                                <span></span>
                            </label>
                        </div>
                    </form-row>
                    <ul class="actions01">
                        <li ng-if="vm.onlineExtraOptions[index]!=true"><a class="btn main small"
                            ng-click="vm.onlineExtraOptions[index]=true">{{ 'occurrence.Display extra options' | translate }}</a></li>
                        <li ng-if="vm.onlineExtraOptions[index]==true"><a class="btn main small"
                            ng-click="vm.onlineExtraOptions[index]=false">{{ 'occurrence.Hide extra options' | translate }}</a></li>
                    </ul>

                </div>
                <div class="form" ng-if="training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK">
                    <form-row error="training.errors.deadline">
                        <label class="label">{{ 'occurrence.Deadline' | translate }}</label>
                        <div class="items">
                            <datetimepicker
                                ng-model="training.deadline"
                                ng-disabled="
                                    !vm.canManageOccurrences ||
                                    vm.MomentService.isPassedDate(training.deadlineOnLoad, 'minute') &&
                                    vm.occurrence.status === vm.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED">
                            </datetimepicker>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
                <courses-courses-edit-occurrence-steps-schedule-training-times
                    ng-if="training.type!=vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
                        && training.type!=vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK
                        && !vm.isThereOnlyOneTestTimeWithoutRoomRequired(training)"
                    occurrence="vm.occurrence"
                    can-manage-occurrences="vm.canManageOccurrences"
                    trainers="vm.trainers"
                    training-companies="vm.trainingCompanies"
                    rooms="vm.rooms"
                    training="training"
                    participants="vm.participants"
                    reload="vm.reload()"
                    training-times-with-participants="vm.trainingTimesWithParticipants"
                />
                <div class="form" ng-if="training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST && training.feedbackFormId">
                    <form-row error="training.errors.feedbackDeadline">
                        <label class="label">{{ 'occurrence.Feedback deadline' | translate }}</label>
                        <div class="items">
                            <datepicker-api ng-model="training.feedbackDeadline" ng-disabled="!vm.canManageOccurrences"></datepicker-api>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
                <div class="form" ng-if="vm.isThereOnlyOneTestTimeWithoutRoomRequired(training)">
                      <form-row error="vm.timeCopies[training.id].errors.timeStart">
                        <span class="label">{{ 'occurrence.Accessible from' | translate }}</span>
                        <div class="items">
                            <datetimepicker
                                ng-model="vm.timeCopies[training.id].timeStart"
                                ng-change="vm.timeCopies[training.id].errors.timeStart = null; vm.timeCopies[training.id].errors.timeEnd = null"
                                default-time="'00:00'">
                            </datetimepicker>
                            <form-row-error></form-row-error>
                        </div>
                      </form-row>
                      <form-row error="vm.timeCopies[training.id].errors.timeEnd">
                        <label class="label">{{ 'occurrence.Deadline' | translate }}</label>
                        <div class="items">
                            <datetimepicker
                                ng-model="vm.timeCopies[training.id].timeEnd"
                                ng-change="vm.timeCopies[training.id].errors.timeStart = null; vm.timeCopies[training.id].errors.timeEnd = null"
                                default-time="'23:59'">
                            </datetimepicker>
                            <form-row-error></form-row-error>
                        </div>
                      </form-row>
                      <form-row error="vm.timeCopies[training.id].errors.trainerIds">
                        <label class="label">{{ 'occurrence.Trainer' | translate }}</label>
                        <div class="items">
                          <tags-input
                            ng-model="vm.timeCopies[training.id].trainers"
                            display-property="displayName"
                            key-property="id"
                            add-from-autocomplete-only="true"
                            replace-spaces-with-dashes="false"
                            on-tag-removed="vm.$scope.$emit('trainer:remove', $tag.id)"
                            placeholder="{{ 'occurrence.Find a trainer' | translate }}">
                            <auto-complete min-length="1" source="vm.filterTrainers($query)"></auto-complete>
                          </tags-input>
                          <form-row-error></form-row-error>
                        </div>
                      </form-row>
                  <form-row error="vm.timeCopies[training.id].errors.trainingCompanyIds">
                    <label class="label">{{ 'occurrence.Training company' | translate }}</label>
                    <div class="items">
                      <tags-input
                        ng-model="vm.timeCopies[training.id].trainingCompanies"
                        display-property="name"
                        add-from-autocomplete-only="true"
                        replace-spaces-with-dashes="false"
                        on-tag-removed="vm.removeTrainingCompanyTrainer(training.id)"
                        placeholder="{{ 'occurrence.Find a company' | translate }}">
                        <auto-complete min-length="1" source="vm.filterTrainingCompanies($query)"></auto-complete>
                      </tags-input>
                      <form-row-error></form-row-error>
                    </div>
                  </form-row>
                  <form-row ng-if="vm.timeCopies[training.id].trainingCompanies.length"
                            error="vm.timeCopies[training.id].errors.trainingCompanyTrainer">
                    <label class="label">{{ 'occurrence.External trainer' | translate }}</label>
                    <div class="items">
                      <input ng-model="vm.timeCopies[training.id].trainingCompanyTrainer" type="text" class="form-control">
                      <form-row-error></form-row-error>
                    </div>
                  </form-row>
                </div>
            </div>
        </div>
        <div class="loader02" ng-if="vm.saving">
            <p>{{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}</p>
        </div>
        <ul class="actions01" ng-if="vm.canManageOccurrences">
            <li class="primary" ng-if="!vm.OccurrenceService.isPublished(vm.occurrence)">
                <a class="btn main" ng-click="vm.confirmSave(true)" ng-class="{true: 'loading', false: ''}[vm.saving]">{{ 'general.Save and publish' | translate }}</a>
            </li>
            <li class="primary"><a class="btn bordered02" ng-click="vm.confirmSave()" ng-class="{true: 'loading', false: ''}[vm.saving]">{{ 'general.Save' | translate }}</a></li>
            <li><a ui-sref="authorized.courses.courses.edit.occurrence.list({id: vm.course.id})" class="btn discrete" >{{ 'general.Cancel' | translate }}</a></li>
        </ul>
        <div ng-if="vm.displayReminderNotification" class="alert is-sticky sticky-bottom sticky-right is-narrow has-icon ico-alert">
            <button ng-click="vm.displayReminderNotification = !vm.displayReminderNotification" class="alert-close has-icon ico-cross" aria-label="Close alert"></button>
            <h3>{{ 'events.Custom notifications enabled' | translate }}</h3>
            <div class="mt10">
                <ul>
                    <div ng-if="vm.notificationsSettingsEnabled">{{ 'events.Notification settings for this course' | translate }}:<br>
                        <div ng-repeat="event in vm.uniqueEvents(vm.course.connectedEvents)">
                            <li ng-if="event.trigger===vm.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_ENROLLED_TO_COURSE">
                                {{ 'events.On course enrollment' | translate }}: {{ vm.EVENT_ACTION_ENUM.LABELS[event.action] }}
                            </li>
                            <li ng-if="event.trigger===vm.EVENT_TRIGGER_ENUM.KEYS.TRAINING_EDITED">
                                {{ 'events.On course edit' | translate }}: {{ vm.EVENT_ACTION_ENUM.LABELS[event.action] }}
                            </li>
                        </div>
                    </div>
                    <div ng-if="vm.remindersSettingsEnabled">
                        <div ng-repeat="event in vm.course.connectedEvents">
                            <div ng-if="event.trigger===vm.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE">
                                <li ng-if="event.action!==vm.EVENT_ACTION_ENUM.KEYS.DO_NOT_SEND_NOTIFICATION">
                                    {{ 'events.Reminders are sent in the following way' | translate }}:<br>
                                    <ul>
                                        <li ng-repeat="reminder in vm.getReminderList(event)">{{ reminder }}</li>
                                    </ul>
                                </li>
                                <li ng-if="event.action===vm.EVENT_ACTION_ENUM.KEYS.DO_NOT_SEND_NOTIFICATION">
                                    {{ 'events.Reminders are not sent' | translate }}
                                </li>
                            </div>
                        </div>
                    </div>
                </ul>
            </div>
        </div>
    `
})
export default class {
    constructor ($rootScope, $scope, $state, $translate, $timeout, lodash,
                ModalService, OccurrenceService, CourseVersionService, MomentService, TokenService,
                OccurrenceResource, RoomResource, UserResource, OccurrenceTrainingService,
                COURSE_TRAINING_ORDER_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM, OCCURRENCE_STATUS_ENUM,
                EVENT_ACTION_ENUM, EVENT_TRIGGER_ENUM, COURSE_TRAINING_TIME_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM,
                COURSE_TRAINING_TIME_INTERVAL_TYPE_ENUM, moment, toastr, $sce
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.OccurrenceService = OccurrenceService;
        this.OccurrenceResource = OccurrenceResource;
        this.CourseVersionService = CourseVersionService;
        this.MomentService = MomentService;
        this.RoomResource = RoomResource;
        this.UserResource = UserResource;
        this.TokenService = TokenService;
        this.OccurrenceTrainingService = OccurrenceTrainingService;
        this.moment = moment;
        this.toastr = toastr;
        this.$sce = $sce;

        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_TIME_TYPE_ENUM = COURSE_TRAINING_TIME_TYPE_ENUM;
        this.COURSE_TRAINING_TIME_INTERVAL_TYPE_ENUM = COURSE_TRAINING_TIME_INTERVAL_TYPE_ENUM;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.EVENT_ACTION_ENUM = EVENT_ACTION_ENUM;
        this.EVENT_TRIGGER_ENUM = EVENT_TRIGGER_ENUM;
        this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM;

        this.saving = false;

        const participantListener = $rootScope.$on('reload:training-time-participants', (event, data) => {
            this.clearErrors();
            const trainingTimeIndex = data.trainingTimeIndex;
            const occurrenceTrainingId = data.occurrenceTrainingId;
            const participantsPromise = this.reloadTrainingTimesWithParticipants();
            this.OccurrenceResource.getTrainings({ id: this.occurrence.id }).$promise
                .then((reloadedOccurrenceTrainings) => {
                    const index = this.lodash.findIndex(reloadedOccurrenceTrainings, (val) => val.id === occurrenceTrainingId);
                    // we overwrite time properties instead of time to prevent participants collapse
                    this.occurrenceTrainings[index].times[trainingTimeIndex]
                        .participantCount = reloadedOccurrenceTrainings[index].times[trainingTimeIndex].participantCount;
                    this.occurrenceTrainings[index].times[trainingTimeIndex]
                        .participantIds = reloadedOccurrenceTrainings[index].times[trainingTimeIndex].participantIds;
                    this.occurrenceTrainings[index].times[trainingTimeIndex]
                        .reportConfirmedBy = reloadedOccurrenceTrainings[index].times[trainingTimeIndex].reportConfirmedBy;
                    this.occurrenceTrainings[index].times[trainingTimeIndex]
                        .isReportConfirmed = reloadedOccurrenceTrainings[index].times[trainingTimeIndex].isReportConfirmed;

                    this.reloadTrainings(occurrenceTrainingId);
                    this.checkClassroomCapacity();
                    // wait until trainingTimeParticipants promise is also resolved and then is worked out, then broadcast
                    participantsPromise.then(() => {
                        this.$timeout(() => {
                            $rootScope.$broadcast('reload:participants');
                        }, 100);
                    });
                });
        });
        $scope.$on('$destroy', participantListener);
        const trainerListener = $rootScope.$on('trainer:remove', (event, trainerId) => {
            const removeTrainer = lodash.includes(this.trainerIdsWithoutTrainerRole, trainerId);
            if (removeTrainer) {
                lodash.remove(this.trainers, item => item.id === trainerId);
            }
        });
        $scope.$on('$destroy', trainerListener);
        this.onlineExtraOptions = [];
        this.timeCopies = {};
    }

    $onInit () {
        this.isTrainersUpdated = false;
        this.findTrainersWithoutRole();
        this.reload();
        this.displayReminderNotification = this.displayReminderNotification();
        this.notificationsSettingsEnabled = this.notificationsSettingsEnabled();
        this.remindersSettingsEnabled = this.remindersSettingsEnabled();
    }

    uniqueEvents (events) {
        const unique = [];
        const indexes = [];
        this.lodash.forEach(events, (event) => {
            const index = `${event.action}-${event.trigger}`;
            if (!indexes.includes(index)) {
                indexes.push(index);
                unique.push(event);
            }
        });
        return unique;
    }

    getReminderList (event) {
        const list = [];
        this.lodash.forEach(event.templates, (template) => {
            if (template.isEnabled) {
                let reminder = null;
                const reminderParts = [];

                this.lodash.forEach(template.times, (time) => {
                    const intervalType = time.interval > 1
                        ? this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM.LABELS[time.intervalType]
                        : this.COURSE_TRAINING_TIME_INTERVAL_TYPE_ENUM.LABELS[time.intervalType];
                    reminderParts.push(
                        `${time.interval} ${intervalType} ${this.COURSE_TRAINING_TIME_TYPE_ENUM.LABELS[time.type].toLowerCase()}`
                    );
                });
                if (reminderParts.length) {
                    reminder = `${this.COURSE_TRAINING_TYPE_ENUM.LABELS[template.moduleType]}: ${reminderParts.join(' and ')}`;
                    list.push(reminder);
                }
            }
        });
        return list;
    }

    displayReminderNotification () {
        if (!this.TokenService.isEventsModuleEnabled()) {
            return false;
        }

        const events = Array.isArray(this.course.connectedEvents) ? this.course.connectedEvents : [];
        if (!events.length) {
            return false;
        }

        const SHOW_TRIGGERS = [
            this.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_ENROLLED_TO_COURSE,
            this.EVENT_TRIGGER_ENUM.KEYS.TRAINING_EDITED,
            this.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE
        ];

        return events.some(e => e && e.isActive && SHOW_TRIGGERS.indexOf(e.trigger) !== -1);
    }

    notificationsSettingsEnabled () {
        let enabled = false;
        const triggersForNotification = [
            this.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_ENROLLED_TO_COURSE,
            this.EVENT_TRIGGER_ENUM.KEYS.TRAINING_EDITED
        ];
        this.lodash.forEach(this.course.connectedEvents, (event) => {
            if (event.isActive && triggersForNotification.includes(event.trigger)) {
                enabled = true;
            }
        });
        return enabled;
    }

    remindersSettingsEnabled () {
        let enabled = false;
        const triggersForNotification = [
            this.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE
        ];
        this.lodash.forEach(this.course.connectedEvents, (event) => {
            if (event.isActive && triggersForNotification.includes(event.trigger)) {
                enabled = true;
            }
        });
        return enabled;
    }

    /**
     * find all trainers that does not have a trainer role anymore for ONLINE, CLASSROOM and TEST types
     * call inside onInit only as not affected by reload()
     */
    findTrainersWithoutRole () {
        this.trainerIdsWithoutTrainerRole = [];
        const trainerIds = this.lodash.map(this.trainers, 'id');
        this.lodash.forEach(this.occurrenceTrainings, (training) => {
            // Find all ids for ONLINE type
            this.lodash.forEach(training.trainerIds, (id) => {
                const intId = parseInt(id, 10);
                if (!this.lodash.includes(trainerIds, intId)) {
                    this.trainerIdsWithoutTrainerRole.push(intId);
                }
            });

            // Find all ids for CLASSROOM and TEST type
            this.lodash.forEach(training.times, (time) => {
                this.lodash.forEach(time.trainerIds, (id) => {
                    const intId = parseInt(id, 10);
                    if (!this.lodash.includes(trainerIds, intId)) {
                        this.trainerIdsWithoutTrainerRole.push(intId);
                    }
                });
            });
        });

        if (!this.trainerIdsWithoutTrainerRole.length) {
            this.isTrainersUpdated = true;
            return;
        }
        this.UserResource.query({
            'ids[]': this.trainerIdsWithoutTrainerRole,
            pageSize: 0
        }).$promise.then((users) => {
            this.trainers = this.lodash.concat(this.trainers, users);
            this.isTrainersUpdated = true;
        });
    }

    reload () {
        if (this.$state.params.dataSaved) {
            this.dataSaved = angular.copy(this.$state.params.dataSaved);
            delete this.$state.params.dataSaved;
        }
        this.courseVersion = this.lodash.find(this.course.courseVersions, { id: this.occurrence.courseVersionId });
        this.isTrainingOrderSequence = this.courseVersion.trainingOrderType === this.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.SEQUENCE;
        this.canManageOccurrences = this.OccurrenceService.canManageScheduleTab(this.occurrence);
        this.OccurrenceResource.getTrainings({ id: this.occurrence.id, privilegesCheck: 0 }).$promise
            .then((reloadedOccurrenceTrainings) => {
                this.occurrenceTrainings = reloadedOccurrenceTrainings;
                this.reloadTrainings();
                this.checkClassroomCapacity();
                this.clearErrors();
            });
        this.reloadTrainingTimesWithParticipants();
    }

    clearErrors () {
        this.errors = false;
        this.occurrence.errors = {};
        this.lodash.forEach(this.trainings, (training) => {
            training.errors = {};
        });

        Object.keys(this.timeCopies || {}).forEach((id) => {
            const tc = this.timeCopies[id];
            if (tc && tc.errors) tc.errors = {};
        });
    }

    filterTrainers (value) {
        return this.trainers.filter((trainer) => this.lodash.includes(trainer.displayName.toUpperCase(), value.toUpperCase()));
    }

    filterTrainingCompanies (value) {
        return this.trainingCompanies.filter((company) => this.lodash.includes(company.name.toUpperCase(), value.toUpperCase()));
    }

    beforeSave (publish) {
        this.occurrence.languages = this.occurrence.courseOccurrenceLanguages.map(val => val.language);
        this.occurrence.directManagerIds = this.occurrence.courseOccurrenceManagers.map(val => val.userId);

        if (this.occurrence.publishDate && !this.isDateValid(this.occurrence.publishDate)) {
            this.occurrence.publishDate = this.MomentService.formatTimeStamp(this.occurrence.publishDate, 'YYYY-MM-DD HH:mm:ss', true);
        }

        // get new participants data as it can updated in last step
        this.OccurrenceResource.getParticipants(
            { pageSize: 0, sort: 'name', privilegesCheck: 0 },
            { occurrenceId: this.occurrence.id }
        ).$promise.then((participants) => {
            // changing the date format to 'YYYY-MM-DD HH:mm:ss' for accessUntil
            if (participants.length > 0) {
                participants.forEach((item) => {
                    if (item.accessUntil && this.moment.unix(item.accessUntil).isValid()) {
                        item.accessUntil = this.MomentService.formatTimeStamp(item.accessUntil, 'YYYY-MM-DD HH:mm:ss', true);
                    }
                    if (item.previousPassedTime && item.previousPassedTime.date) {
                        item.previousPassedTime = item.previousPassedTime.date;
                    }
                });
                this.occurrence.courseOccurrenceParticipants = participants;
            }
        });

        this.trainings = this.trainings.map((training) => {
            this.lodash.assign(training, {
                trainerIds: training.trainers.map((val) => (val.id)),
                // true if publishing occurrence, used to get feedback error msg with correct path
                validateFeedbackDeadline: publish
            });
            return training;
        });
    }

    /**
     * Checks whether date is in the correct format of YYY-MM-DD HH:mm:ss
     *
     * @param {string} date
     */
    isDateValid (date) {
        const regex = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
        return String(date).match(regex);
    }

    isThereOnlyOneTestTimeWithoutRoomRequired (training) {
        // Single-form mode is allowed only when:
        // - training type is TEST
        // - room is not required
        // - there are <=1 existing times (legacy data with >1 times must use list mode)
        const timesCount = (training && Array.isArray(training.times)) ? training.times.length : 0;
        return (
            training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST &&
            training.isRoomRequired === 0 &&
            timesCount <= 1
        );
    }

    save (publish) {
        if (this.saving) {
            return;
        }
        this.beforeSave(publish);
        this.clearErrors();
        const beforeStatus = angular.copy(this.occurrence.status);

        const singleFormTrainings = this.trainings.filter(t => this.isThereOnlyOneTestTimeWithoutRoomRequired(t));

        if (singleFormTrainings.length) {
            // Build a unified payload
            const payload = this.trainings.map(t => {
                if (!this.isThereOnlyOneTestTimeWithoutRoomRequired(t)) return t;

                const tc = this.timeCopies[t.id] || {};
                const tcopy = angular.copy(t);

                const timeObj = angular.copy(tc);
                timeObj.trainingId = t.trainingId;
                timeObj.trainingType = t.type;
                timeObj.trainerIds = (tc.trainers || []).map(u => u.id);
                timeObj.trainingCompanyIds = (tc.trainingCompanies || []).map(c => c.id);
                delete timeObj.trainers;
                delete timeObj.trainingCompanies;
                delete timeObj.occurrence;
                delete timeObj.participantCount;
                tcopy.times = [timeObj];

                tcopy.validateFeedbackDeadline = false;
                this.removeParticipantsFieldsForSingleTest(tcopy);
                return tcopy;
            });

            this.saving = true;

            // validate only
            this.OccurrenceResource
                .setTrainings({ id: this.occurrence.id, validateOnly: true }, payload).$promise
                .then(() => {
                    // proceed with real save (and publish flow if needed)
                    return this.OccurrenceResource.setTrainings({ id: this.occurrence.id }, payload).$promise;
                })
                .then(() => {
                    if (publish) this.occurrence.status = this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED;
                    return this.OccurrenceResource.update({
                        id: this.occurrence.id,
                        expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,sites'
                    }, this.occurrence).$promise;
                })
                .then((occurrence) => {
                    this.$scope.$emit('occurrence:reload', occurrence);
                    this.dataSaved = true;
                    this.clearErrors();
                    this.reload();
                    if (this.$state.includes('authorized.courses.courses.edit.occurrence.add.schedule')) {
                        this.$state.go('authorized.courses.courses.edit.occurrence.edit.schedule', {
                            id: this.$state.params.id,
                            occurrenceId: this.occurrence.id,
                            dataSaved: true
                        });
                    }
                })
                .catch((errors) => {
                    if (publish) this.occurrence.status = beforeStatus;
                    this.clearErrors();
                    this.errors = true;
                    this.dataSaved = false;

                    const list = (errors && errors.data) || [];
                    this.lodash.forEach(list, (error) => {
                        // Map BE errors to either training.errors.* or timeCopies[training.id].errors.*
                        const idx = parseInt(String(error.path).split('.')[0], 10);
                        const affectedTraining = this.trainings[idx];
                        if (affectedTraining && this.isThereOnlyOneTestTimeWithoutRoomRequired(affectedTraining)) {
                            this.lodash.set(this.timeCopies[affectedTraining.id], `errors.${error.field}`, error.message);
                            if (error.field === 'feedbackDeadline') {
                                this.timeCopies[affectedTraining.id].errors.timeEnd = error.message;
                            }
                        }
                        else if (error.path) {
                            this.lodash.set(this.trainings, `${error.path}.errors.${error.field}`, error.message);
                        }
                        else {
                            this.lodash.set(this.occurrence, `errors.${error.field}`, error.message);
                        }
                    });
                })
                .finally(() => {
                    this.saving = false;
                });

            return;
        }

        if (this.isAtLeastOneRoomOverbooked()) {
            this.ModalService.confirm(this.$translate.instant('participants.confirm_over_capacity_message'), 'medium')
                .then(() => this.setTrainings(publish, beforeStatus));
        }
        else {
            this.setTrainings(publish, beforeStatus);
        }
    }

    processSetTrainingsErrorMessage (message, publish) {
        if (message && message.includes('(link to version)')) {
            const link = this.$state.href('authorized.courses.courses.edit.version.edit.training', {
                id: this.course.id,
                versionId: this.courseVersion.id
            });
            message = message.replace(
                '(link to version)',
                `<a href="${link}">${this.$translate.instant('occurrence.Add activities to the course to publish')}</a>`
            );
        }

        if (publish && message) {
            this.toastr.error(message, null, { allowHtml: true });
        }

        if (message && typeof message === 'string' && message.includes('<a href')) {
            message = this.$sce.trustAsHtml(message);
        }

        return message;
    }

    setTrainings (publish, beforeStatus) {
        this.saving = true;
        this.OccurrenceResource.setTrainings({ id: this.occurrence.id }, this.trainings).$promise.then(() => {
            if (publish) {
                this.occurrence.status = this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED;
            }
            this.OccurrenceResource.update({
                id: this.occurrence.id,
                expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,sites'
            }, this.occurrence).$promise.then((occurrence) => {
                this.$scope.$emit('occurrence:reload', occurrence);
                this.dataSaved = true;
                this.clearErrors();
                this.reload();
                if (this.$state.includes('authorized.courses.courses.edit.occurrence.add.schedule')) {
                    this.$state.go('authorized.courses.courses.edit.occurrence.edit.schedule', {
                        id: this.$state.params.id,
                        occurrenceId: this.occurrence.id,
                        dataSaved: true
                    });
                }
            }).catch((errors) => {
                if (publish) {
                    this.occurrence.status = beforeStatus;
                }
                this.errors = true;
                this.dataSaved = false;
                this.lodash.forEach(errors.data, (error) => {
                    const message = this.processSetTrainingsErrorMessage(error.message, publish);
                    this.lodash.set(this.occurrence, `errors.${error.field}`, message);
                });
            });
        }).catch((errors) => {
            if (publish) {
                this.occurrence.status = beforeStatus;
            }
            this.clearErrors();
            this.errors = true;
            this.dataSaved = false;
            this.lodash.forEach(errors.data, (error) => {
                const message = this.processSetTrainingsErrorMessage(error.message, publish);
                this.lodash.set(this.trainings, `${error.path}.errors.${error.field}`, message);
            });
        }).finally(() => {
            this.saving = false;
        });
    }

    confirmSave (publish = false) {
        const {
            $translate,
            occurrence,
            OccurrenceService,
            OccurrenceTrainingService,
            oldTrainings,
            trainings,
            occurrenceTrainings
        } = this;
        const confirmMessages = [];

        const onlineTrainings = this.CourseVersionService.getOnlineTrainingsWoMaterials(
            occurrenceTrainings
        );
        if (onlineTrainings.length && !OccurrenceService.isPublished(occurrence)) {
            const trainingNames = onlineTrainings.map((training) => training.name).join(', ');
            confirmMessages.push(this.$translate.instant(
                'occurrence.alias.online_trainings_wo_materials', { trainingNames }
            ));
        }

        if (!this.CourseVersionService.hasRequiredTrainings(this.courseVersion.courseTrainings)) {
            confirmMessages.push(this.$translate.instant('version.only_online_trainings_message'));
        }

        if (publish) {
            confirmMessages.push($translate.instant(
                'occurrence.After publishing, this course will be accessible to participants and occurrence basic information is no longer editable. Are you sure you wish to publish this occurrence?'
            ));
        }

        if (this.occurrence.status === this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED &&
            OccurrenceTrainingService.isOnlineTrainingDeadlineChanged(oldTrainings, trainings) &&
            this.isTrainingOrderSequence
        ) {
            confirmMessages.push(this.$translate.instant('occurrence.published.confirmation_message_online'));
        }

        if (confirmMessages.length) {
            this.ModalService.confirm(confirmMessages, 'medium')
                .then(() => this.save(publish))
            ;
        }
        else {
            this.save(publish);
        }
    }

    isAtLeastOneRoomOverbooked () {
        const overbooks = [];
        this.lodash.forEach(this.trainings, (training) => {
            this.lodash.forEach(training.times, (time) => {
                const room = time.roomId ? this.getRoom(time.roomId) : null;
                overbooks.push(time.roomId && room && (room.capacity < time.participantCount));
            });
        });
        return this.lodash.includes(overbooks, true);
    }

    checkClassroomCapacity () {
        this.RoomResource.query().$promise.then(rooms => {
            // in case training time was created with new room
            this.rooms = rooms;

            this.classroomIsTooSmall = false;
            this.classroomCapacityAllTogether = 0;
            this.classroomTrainings = this.lodash.filter(this.trainings, (training) => {
                return training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM;
            });

            this.lodash.forEach(this.classroomTrainings, (training) => {
                this.lodash.forEach(training.times, (time) => {
                    if (time.roomId) {
                        const room = this.getRoom(time.roomId);
                        if (room && room.capacity) {
                            this.classroomCapacityAllTogether += room.capacity;
                        }
                    }
                });
            });

            if (this.classroomCapacityAllTogether !== 0 && this.classroomCapacityAllTogether < this.occurrence.courseOccurrenceParticipants.length) {
                this.classroomIsTooSmall = true;
            }
        });
    }

    manageTrainingTime (training) {
        return this.OccurrenceService.manageTrainingTime(
            this.occurrence, this.canManageOccurrences, this.rooms, this.trainers, this.trainingCompanies, training
        ).then((updatedTraining) => {
            const oldTraining = this.lodash.find(this.trainings, { id: updatedTraining.id });
            if (oldTraining) {
                oldTraining.times = updatedTraining.times;
            }
            this.checkClassroomCapacity();
        });
    }

    reloadTrainingTimesWithParticipants () {
        return this.OccurrenceResource.getTrainingTimeParticipants({
            occurrenceId: this.occurrence.id,
            expand: 'courseOccurrenceTrainingTimeParticipants.trainingProgress'
        }).$promise.then((trainingTimesWithParticipants) => {
            this.trainingTimesWithParticipants = trainingTimesWithParticipants;
        });
    }

    reloadTrainings (occurrenceTrainingId) {
        this.trainings = this.occurrenceTrainings.map((val) => {
            if (occurrenceTrainingId && occurrenceTrainingId !== val.id) {
                return val;
            }
            const training = this.lodash.find(this.courseVersion.courseTrainings, { id: val.trainingId });
            const trainingActiveI18n = this.course.courseTrainingsActiveI18n[val.trainingId];
            return this.lodash.merge(val, {
                name: trainingActiveI18n.name,
                learndashCourseId: training.learndashCourseId,
                materialType: training.materialType,
                type: training.type,
                deadlineOnLoad: val.deadline,
                trainers: val.trainerIds.length ? val.trainerIds.map(
                    (id) => (this.lodash.find(this.trainers, { id: parseInt(id, 10) }))
                ) : []
            });
        });
        this.oldTrainings = angular.copy(this.trainings);
        this.hasClassRoomTrainings = this.trainings.some(training => training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM);
        this.hasWebinarTrainings = this.trainings.some(training => training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR);

        this.trainings.forEach(training => {
            if (this.isThereOnlyOneTestTimeWithoutRoomRequired(training)) {
                // default scaffold
                const emptyCopy = {
                    id: undefined,
                    timeStart: undefined,
                    timeEnd: undefined,
                    roomId: undefined,
                    trainers: [],
                    trainingCompanies: [],
                    trainerIds: [],
                    trainingCompanyIds: [],
                    trainingCompanyTrainer: null,
                    participantIds: [],
                    isReportConfirmed: 0,
                    hasCapacity: false,
                    capacity: null,
                    errors: {}
                };

                // if there’s an existing time, seed from it
                const t0 = (training.times && training.times[0]) || null;
                const seeded = t0
                      ? angular.extend({}, angular.copy(t0), {
                          trainers: (t0.trainerIds || []).map(id => this.lodash.find(this.trainers, { id: parseInt(id, 10) })),
                          trainingCompanies: (t0.trainingCompanyIds || []).map(id => this.lodash.find(this.trainingCompanies, { id: parseInt(id, 10) })),
                          errors: {}
                      })
                : emptyCopy;

                if (!this.timeCopies[training.id]) {
                    this.timeCopies[training.id] = seeded;
                }
                else {
                    this.timeCopies[training.id].id = seeded.id ? seeded.id : null;
                    this.timeCopies[training.id].errors = {};
                }
            }
        });
    }

    removeParticipantsFieldsForSingleTest (trainingCopy) {
        if (!this.isThereOnlyOneTestTimeWithoutRoomRequired(trainingCopy)) {
            return;
        }
        const time = (trainingCopy.times && trainingCopy.times[0]) || null;
        if (!time) {
            return;
        }
        // backend rule expects an array; ensure it's [] (not undefined/null)
        if (!Array.isArray(time.participantIds)) {
            time.participantIds = [];
        }
        // count is derived on BE; drop to avoid confusing diffs
        if (typeof time.participantCount !== 'undefined') {
            delete time.participantCount;
        }
    }

    removeTrainingCompanyTrainer (trainingId) {
        if (trainingId && this.timeCopies[trainingId]) {
            const tc = this.timeCopies[trainingId];
            if (!tc.trainingCompanies || !tc.trainingCompanies.length) {
                tc.trainingCompanyTrainer = null;
                if (tc.errors) tc.errors.trainingCompanyTrainer = null; // clear stale error
            }
            return;
        }
        Object.keys(this.timeCopies || {}).forEach(id => {
            const tc = this.timeCopies[id];
            if (!tc || (tc.trainingCompanies && tc.trainingCompanies.length)) return;
            tc.trainingCompanyTrainer = null;
            if (tc.errors) tc.errors.trainingCompanyTrainer = null;
        });
    }

    viewResults (training) {
        const trainingTimesWithParticipants = this.trainingTimesWithParticipants;
        const participants = this.participants;

        this.ModalService.open({
            windowClass: 'drawer-modal',
            size: 'drawer',
            backdrop: true,
            template: `
                <courses-courses-edit-occurrence-steps-schedule-test-results
                    training="vm.training"
                    training-times-with-participants="vm.trainingTimesWithParticipants"
                    participants="vm.participants"
                    uib-modal-instance="vm.$uibModalInstance">
                </courses-courses-edit-occurrence-steps-schedule-test-results>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.training = training;
                this.trainingTimesWithParticipants = trainingTimesWithParticipants;
                this.participants = participants;
            },
            controllerAs: 'vm'
        });
    }

    getRoom (id) {
        return this.lodash.find(this.rooms, { id });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/steps/schedule/index.js